angular.module('core')
  .service('standardsApi', ['cancelableResourceFactory', 'transformResponse', 'nameFilter', function ($cancelableResourceFactory, $transformResponse, $nameFilter) {
    var self = this;

    var studentMapping = function(type, data) {
      data.progressData = [];
      data.xAxisLabels = [];
      var prevProgress = null;

      data.progress.forEach(function(item) {
        // Add logic in here for how to calculate ranges in velocity graph
        var low = (!prevProgress) ? 0 : prevProgress;
        var high = low + item.percent_growth;
        var warn = ((high - low) < 40) ? true : false;
        prevProgress = high;
        data.progressData.push( { low: low, high: high, warn: warn } );
        data.xAxisLabels.push( item.label );
      });

      return data;
    };

    var classroomMapping = function(type, data) {
      data.students = _.map(data.students, function(item) {
        item.name = $nameFilter(item);
        item.type = 'student';
        return item;
      });

      return data;
    };

    var standardsMapping = function(body) {
      var result = {};
      try {
        var jsonBody = JSON.parse(body);
        $transformResponse.transformReportDates(result);
        result = jsonBody.data;
      }
      catch(e) {
        console.error('Standards Transform Error:', e.message);
      }
      return result;
    };

    var StudentGrades = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/levels', {}, {
        get: {
          url: '/r/districts/:districtId/students/:studentId/standards/levels',
          method: 'GET',
          isArray: false,
          transformResponse: function(body, headersGetter, status) {
            return $transformResponse.transformStandards(body, 'grades', studentMapping, status);
          }
        }
    });

    var ClassroomGrades = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/standards/levels', {}, {
      get: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/levels',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'grades', classroomMapping, status);
        }
      }
    });

    var StudentDomains = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains', {}, {
      get: {
        url: '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'domains', studentMapping, status);
        }
      }
    });

    var ClassroomDomains = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains', {}, {
      get: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'domains', classroomMapping, status);
        }
      }
    });

    var StudentStandards = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/clusters', {}, {
      get: {
        url: '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/clusters',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'clusters', studentMapping, status);
        }
      },
      all: {
        url: '/r/districts/:districtId/students/:studentId/standards/all',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return standardsMapping(body);
        }
      }
    });

    var ClassroomStandards = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/clusters', {}, {
      get: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/clusters',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'clusters', classroomMapping, status);
        }
      },
      all: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/all',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return standardsMapping(body);
        }
      }
    });

    var ClassroomStudents = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/standards/:standardId', {}, {
      get: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/standards/:standardId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformStandards(body, 'students', classroomMapping);
        }
      }
    });

    var ClassroomStudentsClusters = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/clusters/:clusterId', {}, {
      get: {
        url: '/r/districts/:districtId/classrooms/:classroomId/standards/levels/:gradeId/domains/:domainId/clusters/:clusterId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, 'students', classroomMapping, status);
        }
      }
    });

    var StudentStandardProgress = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/standards/:standardId', {}, {
      get: {
        url: '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/standards/:standardId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, null, studentMapping, status);
        }
      }
    });

    var StudentClusterProgress = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/clusters/:clusterId', {}, {
      get: {
        url: '/r/districts/:districtId/students/:studentId/standards/levels/:gradeId/domains/:domainId/clusters/:clusterId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformStandards(body, null, studentMapping, status);
        }
      }
    });

    var StandardData = $cancelableResourceFactory.createCacheableResource(null, '/m/mo_group_desc/focus_type/:focus_type/focus_id/:focus_id', {}, {
        get: {
            url: '/m/mo_group_desc/focus_type/:focus_type/focus_id/:focus_id',
            method: 'GET',
            cache: true
        }
    });

    return {
      StudentGrades: StudentGrades,
      StudentDomains: StudentDomains,
      StudentStandards: StudentStandards,
      StudentStandardProgress: StudentStandardProgress,
      StudentClusterProgress: StudentClusterProgress,
      ClassroomGrades: ClassroomGrades,
      ClassroomDomains: ClassroomDomains,
      ClassroomStandards: ClassroomStandards,
      ClassroomStudents: ClassroomStudents,
      ClassroomStudentsClusters: ClassroomStudentsClusters,
      StandardData: StandardData
    };
}]);
